import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { InombraRoutes } from 'src/app/models/routes';
import { MomentPipe } from 'src/app/shared/pipes/moment.pipe';
import { Utils } from 'src/app/shared/services/utilities';

@Component({
  selector: 'app-event-info',
  templateUrl: './event-info.component.html',
  styleUrl: './event-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NzIconModule, MomentPipe, RouterModule],
})
export class EventInfoComponent {
  readonly utils = inject(Utils);
  @Input('event') event;
  readonly InombraRoutes = InombraRoutes;
}
